import SupplierApi from '@/api/supplier.js';
import store from "../../store";

// 如果没有当前门店，就切换到当前门店
export const setCurrentStore = async () => {
    let currentStore = localStorage.getItem('currentStore')
    if (currentStore && Number(currentStore)) {
        // 已有门店，返回
        store.commit('common/setCurrentStore', Number(currentStore))
        return
    }
    let Params = {};
    Params.page = 1;
    Params.list_rows = 1;
    let res = await SupplierApi.supplierList(Params, true)
    if (res && res.code === 1) {
        if (res.data.list.data && Array.isArray(res.data.list.data) && res.data.list.data.length) {
            let id = res.data.list.data[0].shop_supplier_id
            localStorage.setItem('currentStore', id)
            store.commit('common/setCurrentStore', id)
        }
    }
}


// WEBPACK FOOTER //
// ./src/logic/supplier/index.js